import { createContext, useContext, useCallback, useMemo } from 'react';
import { useLocalStorage } from '@aimsos/hooks';

const ShellLayoutContext = createContext(null);

const SIDEBAR_EXPANDED_KEY = 'shell:sidebar:expanded';

/**
 * Provides sidebar expanded state persisted to localStorage.
 * Any descendant can call `useShellLayout()` to read or toggle it.
 */
export const ShellLayoutProvider = ({ children }) => {
  const [expanded, setExpanded] = useLocalStorage(SIDEBAR_EXPANDED_KEY, true);

  const toggleExpanded = useCallback(() => setExpanded((v) => !v), [setExpanded]);

  const value = useMemo(
    () => ({ expanded, toggleExpanded }),
    [expanded, toggleExpanded],
  );

  return <ShellLayoutContext.Provider value={value}>{children}</ShellLayoutContext.Provider>;
};

/**
 * @returns {{ expanded: boolean, toggleExpanded: () => void }}
 */
export const useShellLayout = () => {
  const ctx = useContext(ShellLayoutContext);
  if (!ctx) throw new Error('useShellLayout must be used inside ShellLayoutProvider');
  return ctx;
};
